const THREE = require('three')
import * as SPE from 'shader-particle-engine'
import raf from '../raf'
import {load, loadingManager, registerSize} from '../loader'
import * as trackConfig from '../track-tiled/config'
import clock from '../clock'

// ASSETS
const smokeUrl = require('assets/models/sprites/smoke.jpg')
registerSize(smokeUrl, 29328)

// TEXTURE
let texture = new THREE.Texture()
load(smokeUrl, new THREE.ImageLoader(loadingManager), (results)=> {
  texture.image = results[0]
  texture.needsUpdate = true
})

// MESH
export let mesh = new THREE.Object3D()
mesh.name = `smoke`


const numParticles = 80

// GROUP
export let group = new SPE.Group({
  texture: {
    value: texture
  },
  // blending: THREE.NoBlending,
  // blending: THREE.NormalBlending,
  // blending: THREE.MultiplyBlending,
  // blending: THREE.AdditiveBlending,
  depthTest: false,
  depthWrite: false,
  maxParticleCount: numParticles
  // hasPerspective: true
  // transparent: true,
  // alphaTest: 0.5
  // scale: 10
})

// EMITTER
export let emitter = new SPE.Emitter({
  // type: SPE.distributions.BOX,
  particleCount: numParticles,
  duration: null,
  maxAge: {
    value: 2
  },
  position: {
    value: new THREE.Vector3(0, 0, -240),
    spread: new THREE.Vector3(180, 180, 20),
    randomise: true
  },

  acceleration: {
    value: new THREE.Vector3(0, 0, 100),
    spread: new THREE.Vector3(0, 0, 50)
  },

  velocity: {
    value: new THREE.Vector3(0, 0, 200),
    spread: new THREE.Vector3(0, 0, 20)
  },

  // drag: {
  //   value: 0,
  //   spread: 0
  // },

  // wiggle: {
  //   spread: 10
  // },

  // rotation: {
  //   axis: new THREE.Vector3(0, 1, 0),
  //   // axisSpread: new THREE.Vector3(1, 1, 1),
  //   angel: 90 * THREE.Math.DEG2RAD,
  //   angleSpread: 360 * THREE.Math.DEG2RAD
  // },

  angle: {
    value: [
      0,
      90 * THREE.Math.DEG2RAD
    ],
    spread: [
      90 * THREE.Math.DEG2RAD,
      90 * THREE.Math.DEG2RAD
    ]
  },

  color: {
    value: [
      // new THREE.Color('red'),
      // new THREE.Color(0x0011FF),
      new THREE.Color(0xEB0033)
      // new THREE.Color(0xFFFFFF)
    ]
    // spread: new THREE.Color( 0.1, 0.1, 0.1 )
  },

  opacity: {
    value: [0, 0.3, 0]
  },

  size: {
    value: 150,
    spread: 50
  }

})
emitter.disable()
group.addEmitter( emitter )
group.mesh.renderOrder = 200
mesh.add(group.mesh)

// UPDATE
export const update = function () {
  group.tick()
}
// raf.on('tick', update)



// WEBPACK FOOTER //
// ./src/components/game/effects/smoke.js